import { render, staticRenderFns } from "./BillingReport.vue?vue&type=template&id=484c83a2"
import script from "./BillingReport.vue?vue&type=script&lang=js"
export * from "./BillingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports